export default __webpack_public_path__ + "static/media/cs_video2.0498ef1f.png";